import { useTranslation } from "react-i18next";

import { Stepper, Typography } from "@aviary";
import { l } from "@unauthenticated/oauth/locales/i18n";

import { OAuthStep } from "../oauthStep";

import * as styles from "./OAuthStepHeader.styles";

interface Props {
  currentStep: OAuthStep;
  hideStepper?: boolean;
}

const OAuthStepHeader = ({ hideStepper, currentStep }: Props) => {
  const { t } = useTranslation();
  const offset = OAuthStep.EXTERNAL_APPLICATION;

  const OAuthStepLabels = [
    { label: t(l.oauth.Verify) },
    { label: t(l.oauth.Profit) },
    { label: t(l.oauth.BankInfo) },
  ];

  return (
    <div css={styles.main}>
      <Typography type="h2">{t(l.oauth.WelcomeToFullscript)}</Typography>
      <Typography css={styles.description} type="h3">
        {t(l.oauth.InformationToGetStarted)}
      </Typography>
      <div css={styles.stepperWrapper}>
        {!hideStepper && (
          <Stepper
            currentStep={currentStep - offset}
            steps={OAuthStepLabels}
            isDashed
            isIncompleteFinalStep
          />
        )}
      </div>
    </div>
  );
};

export { OAuthStepHeader };
